/**
 * DynAngleHandle — opens the dial of a rotation parameter.
 *
 * Provisional: ODA exposes a rotation parameter's base point but not its axis, so a
 * real rotation grip cannot be placed where AutoCAD puts it (see the note in
 * blocks/dynamicGrouping). Until that is fixed, this grip only opens the dial, where
 * the block turns live under the pointer.
 *
 * It sits on the LEFT of the selection: flips and value lists already stack along the
 * right edge, and a fourth column there would bury the drawing.
 */

import { HandleType, HANDLE_SIZES } from "../types";
import { DynPickHandle } from "./DynPickHandle";
import type { DynBlockPickKind } from "../../blocks/dynPickBus";

const DYN_ANGLE_DRAW_OPTIONS = {
  fillColor: [70, 130, 220] as [number, number, number],
  strokeColor: [255, 255, 255] as [number, number, number],
  // Filled sector — the wedge the dial draws, so grip and dial match.
  shape: "angleSector" as const,
  radius: HANDLE_SIZES.default * HANDLE_SIZES.handleScale,
};

export class DynAngleHandle extends DynPickHandle {
  readonly type = HandleType.DynAngle;
  protected readonly kind: DynBlockPickKind = "angle";

  // A subclass field initializer runs after super(), so this wins over the default
  // set in AbstractHandle.
  drawOptions = { ...DYN_ANGLE_DRAW_OPTIONS };
}
